import clsx from 'clsx';
import React from 'react';

export const PageCard: React.FC<React.ComponentPropsWithRef<'div'>> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(
        'sm:shadow sm:rounded sm:bg-white',
        'px-6 py-4',
        'sm:px-8 sm:py-10 w-full sm:w-[448px]',
        className,
      )}
      {...props}
    />
  );
};
